export const LOGIN_PATH = 'login';
export const FORGOT_PASSWORD_PATH = 'forgot-password';
export const HOME_PATH = 'home';
export const HELP_SUPPORT = 'help-support';
export const CREATE_ASSESSMENT_PATH = 'create';
export const ASSESSMENT_VIEW_PATH = 'assessment';
export const ASSESSMENT_ID_PATH_PARAM = 'assessmentID';
export const ASSESSMENT_LIST_PATH = 'assessments';
export const THERAPIST_PATH = 'therapists';
export const THERAPIST_ID_PATH_PARAM = 'therapistID';
export const RESET_PASSWORD = 'reset-password';
export const CHANGE_INITIAL_PASSWORD = 'change-initial-password';
